<template>
  <router-link to="/policy">
    <div class="dashboard_box coi-box">
      <div class="icon">
        <img src="@/assets/images/insurecareteams/dashboard/coi.png">
      </div>
      <div class="heading">
        <span class="small-heading">I want to download my</span>
        <h3>Policy and COI</h3>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
     name: 'COIWidget',
};
</script>

<style scoped lang="scss">
.icon {
     position: relative;
}

svg {
     fill: white;
     width: 39px;
     height: 52px;
     position: absolute;
     top: 50%;
     left: 50%;
     transform: translate(-50%, -50%);
}
</style>